import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "../css/WaitingProductsQueue.css";

const withTooltip = (id, title, child) => (
  <OverlayTrigger placement="top" transition={false} overlay={<Tooltip id={id}>{title}</Tooltip>}>
    {child}
  </OverlayTrigger>
);

// Position de la commande dans la file des manquants : pastille ronde,
// la prochaine que recevra un préparateur en vert.
export const QueuePositionBadge = ({ id, position, title }) => withTooltip(
  `tooltip-queue-${id}`,
  title,
  <span className={"queue-position" + (position === 1 ? " queue-position-next" : "")} aria-label={title}>
    {position}
  </span>
);

QueuePositionBadge.propTypes = {
  id: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  title: PropTypes.string,
};

// Pourquoi aucun préparateur ne recevra la commande : une icône, une raison.
const REASON_ICONS = {
  // il ne manque que des produits ajoutés à l'expédition
  nothing_to_search: "fa-boxes-packing",
  // pas de zone de dépôt
  no_transit_area: "fa-location-dot",
};

export const WaitingReasonIcon = ({ id, reason, title }) => {
  const icon = REASON_ICONS[reason];
  if (!icon) return null;
  return withTooltip(
    `tooltip-queue-${id}`,
    title,
    <i className={"fa-solid queue-reason queue-reason-" + reason.replace(/_/g, "-") + " " + icon} aria-label={title}></i>
  );
};

WaitingReasonIcon.propTypes = {
  id: PropTypes.number.isRequired,
  reason: PropTypes.oneOf(Object.keys(REASON_ICONS)).isRequired,
  title: PropTypes.string,
};
